export const ROW_GUTTER = 16;
export const SIDE_NAV_WIDTH = 250;
export const SIDE_NAV_COLLAPSED_WIDTH = 80;
export const SIDE_NAV_LIGHT = 'SIDE_NAV_LIGHT';
export const SIDE_NAV_DARK = 'SIDE_NAV_DARK';
export const NAV_TYPE_SIDE = 'SIDE'
export const NAV_TYPE_TOP = 'TOP'
export const DIR_LTR = 'ltr'
export const DIR_RTL = 'rtl'

export const THEME_COLOR = {
  LIGHT: 'light',
  DARK: 'dark',
};

export const SIDE_NAV = {
  SIDE_NAV_LIGHT: 'SIDE_NAV_LIGHT',
  SIDE_NAV_DARK: 'SIDE_NAV_DARK'
};

export const NAV_TYPE = {
  NAV_TYPE_SIDE: 'NAV_TYPE_SIDE',
  NAV_TYPE_TOP: 'NAV_TYPE_TOP',
};
